import { useState } from "react";
import { Loader2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

export function DeleteJobDialog({ job, candidateCount, onDeleted, children }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const remove = async () => {
    setBusy(true);
    try {
      await api.delete(`/jobs/${job.id}`);
      toast.success(`"${job.title}" and its evaluations were deleted`);
      setOpen(false);
      onDeleted?.();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <div onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }}>{children}</div>
      <AlertDialogContent data-testid="delete-job-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete "{job.title}"?</AlertDialogTitle>
          <AlertDialogDescription>
            This permanently removes the job, its scoring matrix and
            {candidateCount ? ` all ${candidateCount} evaluated candidate report(s)` : " any evaluated candidate reports"}.
            Credits already spent on those evaluations are not refunded. This cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-job-cancel-btn">Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => { e.preventDefault(); remove(); }}
            disabled={busy}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            data-testid="delete-job-confirm-btn"
          >
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Delete Job"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
